import styled from "styled-components";

export const StyledMHWrapper = styled.div<{
    $hasDebt: boolean;
    $hasUncompletedTask: boolean;
}>`
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 16px;

    &::before {
        display: ${(props) =>
            props.$hasDebt || props.$hasUncompletedTask ? "block" : "none"};
        content: "";
        position: absolute;
        left: 0px;
        top: 0px;
        width: 5px;
        height: 100%;
        background-color: ${(props) =>
            props.$hasDebt ? "#ff4d4f " : "#f16a1b"};
    }
`;
